import { defineComponent as _defineComponent } from 'vue'
import type { FilterCollection } from '@/stores/useFilterStoreTypes';

import { computed, ref } from 'vue';

import type Provider from '@/interfaces/provider';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBarProviderMulti',
  props: {
    providers: null,
    currentFilters: null,
    userSelectedPackages: null,
    updateRouteState: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	providers: Provider[];
	currentFilters: FilterCollection;
	userSelectedPackages: string[];
	updateRouteState: boolean;
};

const router = useRouter();
const filterStore = useFilterStore();



const collapsed = ref(true);

const extraProviders = computed(() => `+${props.providers.length - 3}`);

function toggleCollapsed() {
	collapsed.value = !collapsed.value;
}

async function toggleProvider(providerName: string) {
	const isActive: 1 | 0 = props.currentFilters.providers.includes(providerName) ? 0 : 1;
	const toggleData = {
		filterName: 'providers' as keyof FilterCollection,
		value: providerName,
		selectedState: isActive,
		updateRouteState: props.updateRouteState,
		userSelectedPackages: props.userSelectedPackages ?? [],
		trackEvent: true,
	};

	const newRoute = await filterStore.toggle(toggleData);
	if (newRoute) router.push(newRoute);
}

return { __sfc: true,router, filterStore, props, collapsed, extraProviders, toggleCollapsed, toggleProvider, ProviderIcon, HiddenHorizontalScrollbar, faTimes }
}

})